import * as React from "react";
import { cn } from "@util/tailwind";
import { X } from "lucide-react";

interface ToastProps {
    message: string;
    visible: boolean;
    onClose: () => void;
    className?: string;
}

export default function Toast({
    message,
    visible,
    onClose,
    className,
}: ToastProps) {
    React.useEffect(() => {
        if (visible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div
            className={cn(
                "fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 flex items-center justify-center sm:justify-between gap-2 bg-gray-800 dark:bg-gray-700 text-white px-4 py-2 rounded-md shadow-lg transition-opacity duration-300 w-[90%] sm:w-auto",
                className
            )}
        >
            <span>{message}</span>
            <button
                onClick={onClose}
                className="p-1 hover:bg-gray-700 dark:hover:bg-gray-600 rounded-full"
            >
                <X className="h-4 w-4" />
            </button>
        </div>
    );
}
